import React from 'react';
import '../Stylesheets/index.css';

function Body() {
    return (
        <div id="ApplicationBottom">
            <a href="/imprint">Imprint</a>
            <a href="/policy">Policy</a>
        </div>
    );
}

export default Body;
